module.exports = __webpack_public_path__ + "img/logo_cn.e94025bb.gif";